import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import {
  MatFormField,
  MatInput,
  MatLabel,
  MatPrefix
} from '@angular/material/input';
import { HlCurrencyPipe } from '../../pipes/hl-currency.pipe';
import { AsyncPipe } from '@angular/common';
import { AddCurrencyPrefixDirective } from '../../directives/add-currency-prefix.directive';
import { KeyValuePairComponent } from '../../general/key-value-pair/key-value-pair.component';
import { Docket } from 'src/app/models';
import { DocketService } from '../../services/docket.service';

@Component({
  selector: 'app-discount-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatInput,
    MatFormField,
    MatLabel,
    MatButtonModule,
    MatPrefix,
    HlCurrencyPipe,
    AsyncPipe,
    AddCurrencyPrefixDirective,
    KeyValuePairComponent
  ],
  templateUrl: './discount-dialog.component.html'
})
export class DiscountDialogComponent {
  private dialog = inject(MatDialogRef<DiscountDialogComponent>);
  private docketService = inject(DocketService);
  data = inject<{
    totalExDiscount: number;
    docket: Docket;
  }>(MAT_DIALOG_DATA);

  discountControl = new FormControl<number>(
    (this.data.docket.discount * this.data.docket.currency_rate) / 100
  );

  saveDiscount() {
    this.docketService
      .update(this.data.docket.id, {
        discount: this.discountControl.value
          ? (this.discountControl.value / this.data.docket.currency_rate) * 100
          : 0
      })
      .subscribe(() => {
        this.dialog.close(true);
      });
  }
}
